import { Clock3 } from 'lucide-react';
import { useAuth } from '@/lib/auth-context';

export function TenantExpirationBanner() {
  const { user } = useAuth();
  if (user?.tenantAccessMode !== 'expired_read_only') return null;
  const days = Math.max(1, Number(user.tenantGraceDaysRemaining || 1));
  return (
    <div role="alert" className="flex shrink-0 items-center justify-center gap-2 border-b border-red-200 bg-red-50 px-4 py-2 text-xs font-medium text-red-800">
      <Clock3 className="h-4 w-4 shrink-0" />
      <span>Tenant billing expired, {days} {days === 1 ? 'day' : 'days'} left to download data</span>
    </div>
  );
}
